<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 11" width="22" height="11" class="drop-down-arrow">
    <polyline fill="#333" stroke="#000" stroke-width="1" points="0,11 1,11 11,1 21,11 22,11"></polyline>
</svg>
<div class="drop-down-content-wrapper">
    <ng-container [ngTemplateOutlet]="template"></ng-container>
</div>
